/* @flow */
// typecheck: ignore file
import React from 'react';
import { connect } from 'react-redux';
import type { ClassMembershipFetchOptions } from 'sagas/peopleTables';
import { initializeTable, loadMemberships } from 'reducers/peopleTables';
import PeopleTableBody from 'components/PeopleTableBody.jsx';
import GroupMembership from 'entities/GroupMembership';
import type { Filters } from 'reducers/tables';
import { bindActionCreators } from 'redux';
import Group from 'entities/Group';

const PER_PAGE = 20;

type Props = {
  sort: string,
  group: Group,
  query: string,
  filters: Filters,
  disabled?: boolean,

  /* redux props */
  page?: number,
  allLoaded?: boolean,
  initialized: boolean,
  memberships?: GroupMembership[],
  initializeTable: (groupId: number) => any,
  loadMemberships: (groupId: number, options: ClassMembershipFetchOptions) => any,
}

class PeopleTableBodyContainer extends React.Component {
  props: Props;

  componentWillMount() {
    if (!this.props.initialized) {
      this.props.initializeTable(this.props.group.id);
    }
  }

  componentWillUpdate(nextProps: Props) {
    const initialized = !this.props.initialized && nextProps.initialized;
    const newFilters = this.props.filters !== nextProps.filters;
    const newQuery = this.props.query !== nextProps.query;
    const newSort = this.props.sort !== nextProps.sort;

    if (initialized || newSort || newQuery || newFilters) {
      this.loadPage(1, nextProps);
    }
  }

  loadPage(page: number, nextProps?: Props) {
    const props = nextProps || this.props;

    let sortOptions = {};

    if (props.sort) {
      switch (props.sort) {
        case 'first_name_asc':
          sortOptions = { sort: 'first_name', direction: 'asc' };
          break;
        case 'first_name_desc':
          sortOptions = { sort: 'first_name', direction: 'desc' };
          break;
        case 'last_name_asc':
          sortOptions = { sort: 'last_name', direction: 'asc' };
          break;
        case 'last_name_desc':
          sortOptions = { sort: 'last_name', direction: 'desc' };
          break;
        case 'join_date_asc':
          sortOptions = { sort: 'join_date', direction: 'asc' };
          break;
        case 'join_date_desc':
          sortOptions = { sort: 'join_date', direction: 'desc' };
          break;
        case 'role_asc':
          sortOptions = { sort: 'role', direction: 'asc' };
          break;
        case 'role_desc':
          sortOptions = { sort: 'role', direction: 'desc' };
          break;
        default:
      }
    }

    const filterKeys = props.filters.toArray().map(filter => filter.key);

    this.props.loadMemberships(this.props.group.id, {
      page,
      perPage: PER_PAGE,
      query: props.query,
      roles: filterKeys,
      sort: sortOptions.sort,
      sortDirection: sortOptions.direction,
    });
  }

  loadNextPage = () => this.loadPage(this.props.page + 1);

  render() {
    if (!this.props.initialized) {
      return <tbody />;
    }

    return (
      <PeopleTableBody
        group={this.props.group}
        loadNextPage={this.loadNextPage}
        allLoaded={this.props.allLoaded}
        memberships={this.props.memberships}
        disabled={this.props.disabled}
      />
    );
  }
}

function mapStateToProps(state: any, props: Props) {
  const table = state.peopleTables.get(props.group.id);

  if (!table) {
    return { initialized: false };
  }

  return {
    initialized: true,
    page: table.page,
    loading: table.loading,
    allLoaded: table.allLoaded,
    memberships: table.memberships,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ initializeTable, loadMemberships }, dispatch);
}

export { PeopleTableBodyContainer };
export default connect(mapStateToProps, mapDispatchToProps)(PeopleTableBodyContainer);



// WEBPACK FOOTER //
// ./src/components/PeopleTableBodyContainer.jsx